import { create } from 'zustand';

type ChatDemoStore = {
  isResponseViewerOpen: boolean;
  setResponseViewerOpen: (isResponseViewerOpen: boolean) => void;
};

export const useChatDemoStore = create<ChatDemoStore>(set => ({
  isResponseViewerOpen: false,
  setResponseViewerOpen: (isResponseViewerOpen: boolean) => set({ isResponseViewerOpen }),
}));
